// Per-image photo attribution.
// Default credit (Emily Joy Ashman) applies to the original farm-*.jpg set;
// photos supplied by The Transient Image (Vlai Ly) live under /images/wf/vlai/
// (plus a handful of earlier frames from the same shoot: 3503, 3634, 3754, 3777).

import { PHOTO_CREDIT } from "@/content/worldFarmers";

export const VLAI_CREDIT = {
  label: "Photo by Vlai Ly, The Transient Image",
  href: null,
};

const VLAI_LEGACY = new Set([
  "/images/wf/farm-3503.jpg",
  "/images/wf/farm-3634.jpg",
  "/images/wf/farm-3754.jpg",
  "/images/wf/farm-3777.jpg",
]);

export const isVlaiPhoto = (src = "") => src.includes("/images/wf/vlai/") || VLAI_LEGACY.has(src);

/** Returns { label, href } for a given image path. */
export const getPhotoCredit = (src) => (isVlaiPhoto(src) ? VLAI_CREDIT : PHOTO_CREDIT);
